import React from 'react';
import Title from './Title';

const Confirmation = ()=> {
    return (
        <Title>Your card has been successfully sent!</Title>
    );
};

export default Confirmation;